<template>
    <tr class="af-row">
        <td colspan="5" class="td-main">
            <div class="row-grid">
                <div class="cell cell-title">
                    <div class="af-desc title" :class="{ 'is-expanded': !!item._expanded }" :title="item.description">
                        {{ item.description || '—' }}
                    </div>

                    <button v-if="shouldShowMore(item.description)" class="af-link" @click="toggleExpand">
                        {{ item._expanded ? 'Ver menos' : 'Ver mais' }}
                    </button>
                </div>

                <div class="cell cell-badge">
                    <span class="af-badge" :class="badgeClass(displayStatus)">
                        {{ displayStatus }}
                    </span>
                </div>

                <div class="cell cell-meta">
                    <div class="meta-group">
                        <div v-if="item.createdBy || item.createdAt" class="meta-item">
                            <i class="fa-solid fa-user"></i>
                            <span class="meta-label">Solicitado por</span>
                            <span class="meta-value" :title="item.createdBy">{{ item.createdBy }}</span>
                            <span class="meta-sep">•</span>
                            <i class="fa-regular fa-calendar"></i>
                            <span class="meta-value">{{ item.createdAt }}</span>
                        </div>
                        <div v-if="displayStatus != 'Pendente'" class="meta-item">
                            <i class="fa-solid fa-user-pen"></i>
                            <span class="meta-label">
                                <span>{{ displayStatus }}</span>
                                por
                            </span>
                            <span class="meta-value" :title="item.decidedBy">{{ item.decidedBy }}</span>
                            <span class="meta-sep" v-if="item.decidedAt">•</span>
                            <i v-if="item.decidedAt" class="fa-regular fa-calendar"></i>
                            <span class="meta-value" v-if="item.decidedAt">{{ item.decidedAt }}</span>
                        </div>
                    </div>
                </div>

                <div class="cell cell-actions">
                    <div v-if="loading" class="loading-wrap">
                        <vue-loading type="bubbles" color="#D98621" :size="{ width: '26px', height: '26px' }" />
                    </div>

                    <div v-else class="af-linkbar">
                        <button v-if="displayStatus === 'Pendente' && userLogged.user.userName !== 'UserTemp'"
                            class="af-link-btn af-link-btn--success" @click="updateStatus('Aprovado')" title="Aprovar"
                            aria-label="Aprovar">
                            <i class="fa-solid fa-check"></i> Aprovar
                        </button>

                        <button v-if="displayStatus === 'Pendente' && userLogged.user.userName !== 'UserTemp'"
                            class="af-link-btn af-link-btn--danger" @click="updateStatus('Reprovado')" title="Reprovar"
                            aria-label="Reprovar">
                            <i class="fa-solid fa-ban"></i> Reprovar
                        </button>

                        <button v-if="userLogged.user.userName === 'UserTemp'" class="af-link-btn af-link-btn--remove"
                            @click="updateStatus('Removido')" title="Remover" aria-label="Remover">
                            <i class="fa-solid fa-trash"></i> Remover
                        </button>
                    </div>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
    name: "AuthorizationRow",
    props: { item: { type: Object, required: true } },
    data() {
        return {
            urlUpdate: "/api/v1/adm/authorization/update",
            urlDelete: "/api/v1/adm/authorization/delete",
            loading: false,
        };
    },
    computed: {
        ...mapState("user", ["userLogged"]),
        displayStatus() {
            return this.item.status || "Pendente";
        },
    },
    methods: {
        ...mapActions("generic", ["putApi", "deleteApi"]),
        ...mapMutations("generic", ["addEvent"]),

        updateStatus(status) {
            this.loading = true;
            const params = { url: this.urlUpdate, obj: { id: this.item.id, any: status } };
            this.putApi(params)
                .then(() => this.addEvent({ name: "getAllAuthorization" }))
                .finally(() => (this.loading = false));
        },

        remove() {
            this.loading = true;
            const url = `${this.urlDelete}?id=${this.item.id}`;
            const params = { url, obj: {}, notNotifyToast: true };
            this.deleteApi(params)
                .then(() => this.addEvent({ name: "getAllAuthorization" }))
                .finally(() => (this.loading = false));
        },

        toggleExpand() {
            this.$set(this.item, "_expanded", !this.item._expanded);
        },
        shouldShowMore(text) {
            return !!text && text.length > 120;
        },
        badgeClass(status) {
            switch ((status || "").toLowerCase()) {
                case "pendente": return "af-badge--pending";
                case "aprovado": return "af-badge--success";
                case "reprovado": return "af-badge--danger";
                case "finalizado": return "af-badge--info";
                default: return "af-badge--pending";
            }
        },
    },
};
</script>

<style scoped>
.td-main {
    padding: 14px 16px;
}

.row-grid {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto;
    gap: 8px 16px;
}

.cell-title {
    grid-column: 1;
    grid-row: 1;
}

.cell-badge {
    grid-column: 2;
    grid-row: 1;
    justify-self: end;
}

.cell-meta {
    grid-column: 1;
    grid-row: 2;
}

.cell-actions {
    grid-column: 2;
    grid-row: 2;
    justify-self: end;
}

/* Título */
.af-desc {
    font-size: 13px;
    line-height: 1.45;
    color: #111827;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.af-desc.is-expanded {
    display: block;
    -webkit-line-clamp: unset;
}

.af-link {
    margin-top: 6px;
    font-size: 11px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 8px;
    border: 1px solid #e6e7eb;
    color: #577696;
    background: #fff;
    cursor: pointer;
}

.af-link:hover {
    background: #f9fafb;
}

/* Metadados */
.meta-group {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 16px;
    color: #6b7280;
}

.meta-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
}

.meta-item i {
    color: #9ca3af;
    font-size: 12px;
}

.meta-label {
    font-weight: 700;
    color: #4b5563;
}

.meta-value {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.meta-sep {
    opacity: .5;
}

/* Badge */
.af-badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 800;
    border: 1px solid #e6e7eb;
}

.af-badge--pending {
    background: #fff7ed;
    color: #d98621;
    border-color: #fdba74;
}

.af-badge--success {
    background: #ecfdf5;
    color: #065f46;
    border-color: #a7f3d0;
}

.af-badge--danger {
    background: #fef2f2;
    color: #b91c1c;
    border-color: #fecaca;
}

.af-badge--info {
    background: #eff6ff;
    color: #1e40af;
    border-color: #bfdbfe;
}

/* Ações em formato link */
.af-linkbar {
    display: flex;
    gap: 12px;
}

.af-link-btn {
    background: none;
    border: none;
    color: #577696;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    padding: 0;
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.af-link-btn:hover {
    text-decoration: underline;
}

/* Variações de cor */
.af-link-btn--success {
    color: #16a34a;
}

.af-link-btn--danger {
    color: #dc2626;
}

.af-link-btn--remove {
    color: red;
}
</style>

